var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"global_wrapper newform1 apply applicant-verify\"><navbar></navbar><!--subnavbar--><div class=\"wrapper\"><flash-message id=\"error_message\"></flash-message><div class=\"container apply-container active\"><div ui-view=\"\"></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/verifications/verifications.jade
// module id = 1154
// module chunks = 0